export default __webpack_public_path__ + "static/media/Thumb_Hairstyle_16.d60218dc.png";